'use strict';

var FlightLegFilterFactory = function FlightLegFilterFactory(DataFilter) {
  function FlightLegFilter() {
    this.sourceType = ['cabin', 'cabin-da', 'cabin-post-departure', 'class'];
    this.filterType = 'legs';
  }
  FlightLegFilter.constructor = FlightLegFilter;
  FlightLegFilter.prototype = Object.create(DataFilter.prototype);
  FlightLegFilter.prototype.groupBy = 'leg';
  return FlightLegFilter;
};
FlightLegFilterFactory.$inject = ['DataFilterFactory'];
module.exports = FlightLegFilterFactory;